<template>
  <div>
    <div>
      <div class="col-lg-12">
        <filter-options
          v-bind:pageTitle="pageTitle"
          v-bind:filterItems="filterItems"
          v-on:filter-updated="filterLicence"
        />
      </div>

      <div>
        <div class="col-lg-12" style="margin-bottom: 8px;" v-show="totalRows">
          <b-button size="sm" @click="downloadExcelOverview()">{{ $t('excel_export') }}</b-button>
        </div>

        <b-table
          responsive
          show-empty
          :empty-text="$t('no_expired_licences_were_found')"
          ref="table_licence"
          :busy.sync="isBusy"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :current-page="currentPage"
          :per-page="perPage"
          :items="serviceContractsProvider"
          :fields="fields"
          @sort-changed="sortingChanged"
        >
          <template v-slot:table-busy>
            <div style="height: 32px;">
              <div class="mb-3" style="color: #18385f; position: absolute; left: 50%;">
                <b-spinner></b-spinner>
              </div>
            </div>
          </template>

          <template v-slot:cell(licenseExpirationDate)="data">{{getDateFormatted(data.value)}}</template>
        </b-table>

        <div class="row" style="text-align: left;">
          <div class="col-sm-6 offset-sm-3">
            <b-pagination
              v-if="totalRows > 0"
              align="center"
              ref="bottomPagination"
              label-prev-page="first"
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
              class="my-0"
              style="margin-top: 10px !important"
            />
          </div>

          <div class="col-sm-3">
            <div class="form-group row" style="margin-top: 10px;">
              <label
                for="inputPassword"
                class="col-sm-7 col-form-label text-right"
              >{{ $t('lines_per_page') }}</label>
              <div class="col-sm-5">
                <b-form-select
                  :options="pageOptions"
                  v-model="perPage"
                  :change="rowsPerPageChange()"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { odata } from './../../mixins/odata.js';
import { grid } from './../../mixins/grid.js';
import FilterOptions from '@/components/filter/FilterOptions.vue';
import { bus } from './../../main.js';

export default {
  name: 'LicenceOverview',
  mixins: [odata, grid],
  components: {
    filterOptions: FilterOptions
  },
  data: function() {
    return {
      filterItems: getFilterDefinition(this),
      pageTitle: 'expired_licenses',
      filter: this.getFilter(this, 'li-filter').filterString,
      isBusy: false,
      sortBy: this.getSortBy(this, 'li-sortBy', 'licenseExpirationDate'),
      sortDesc: this.getSortDesc(this, 'lo-sortDesc', false),
      fields: getTableFields(this),
      totalRows: 0,
      currentPage: this.getCurrentPage(this, 'li-currentPage', 1),
      perPage: this.getPerPage(this, 'li-perPage', calculateRowsOnScreen()),
      pageOptions: this.getRowsPerPageOptions(null)
    };
  },
  methods: {
    filterLicence(filters) {
      var filterObject = {
        filterString: '',
        items: []
      };

      this.currentPage = 1;
      this.setCurrentPage(this, 'li-currentPage', 1);

      for (let i = 0; i < filters.length; ++i) {
        let filter = filters[i];
        if (filter.value) {
          var item = {
            id: filter.id,
            value: filter.value
          };

          filterObject.items.push(item);
        }
      }

      this.filter = this.getFilterString(filters);

      filterObject.filterString = this.filter;

      var jsonItems = JSON.stringify(filterObject);

      this.setFilter(this, 'li-filter', jsonItems);

      var self = this;

      setTimeout(function() {
        self.$refs.table_licence.refresh();
      }, 500);
    },
    sortingChanged(ctx) {
      ctx.currentPage = 1;
      this.setCurrentPage(this, 'li-currentPage', 1);
    },
    serviceContractsProvider(ctx) {
      var today = this.$moment().format('YYYY-MM-DD');

      var filterString =
        '&$filter=(licenseExpirationDate ge 1965-01-01 and licenseExpirationDate le ' +
        today +
        ')';

      var url = this.getServiceUr(
        'salesGroups',
        ctx,
        filterString,
        this.generateOdataOrderByConditionString(
          ctx.sortBy,
          ctx.sortDesc,
          'dashboard'
        )
      );

      this.setSortBy(this, 'li-sortBy', ctx.sortBy);
      this.setSortDesc(this, 'li-sortDesc', ctx.sortDesc);
      this.setCurrentPage(this, 'li-currentPage', ctx.currentPage);

      let promise = this.$axios.get(url);

      return promise
        .then(data => {
          const items = data.data.value;

          this.totalRows = data.data.count;

          this.currentPage = this.getCurrentPage(this, 'li-currentPage', 1);

          return items;
        })
        .catch(error => {
          console.log(error);

          return [];
        });
    },
    changeLanguageHandler() {
      this.fields = getTableFields(this);
      this.$refs.table_licence.refresh();
    },
    rowsPerPageChange: function() {
      this.setPerPage(this, 'li-perPage', this.perPage);
    },
    getDateFormatted: function(date) {
      return date === null || date === ''
        ? ''
        : this.$moment(date).format('DD/MM/YYYY');
    },
    downloadExcelOverview: function(docment) {
      let documentName = 'duomed-portal-expired-licences';

      var sl = this.$i18n.locale;

      this.$axios({
        url: 'salesgroups/downloadexpiredlicensesoverview?fileName=' + documentName + '&language=' + sl,
        method: 'GET',
        responseType: 'blob'
      })
        .then(response => {
          if (navigator.msSaveBlob) {
            return navigator.msSaveBlob(
              new Blob([response.data]),
              documentName + '.xlsx'
            );
          } else {
            const url = window.URL.createObjectURL(new Blob([response.data]));

            const link = window.document.createElement('a');
            link.href = url;
            link.setAttribute('download', documentName + '.xlsx');
            window.document.body.appendChild(link);
            link.click();
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  created() {
    bus.$on('languageChanged', this.changeLanguageHandler);
  },
  beforeDestroy() {
    bus.$off('languageChanged', this.changeLanguageHandler);
  }
};

function calculateRowsOnScreen() {
  return 10;
}

function getFilterDefinition(context) {
  var filter = context.getFilter(context, 'li-filter');

  const filterDefinition = [];

  filter.items.forEach(item => {
    filterDefinition.forEach(filter => {
      if (item.id === filter.id) {
        filter.value = item.value;
      }
    });
  });

  return filterDefinition;
}

function getTableFields(context) {
  return [
    {
      key: 'salesGroupName',
      label: context.$t('name'),
      sortable: true,
      thClass: 'tr-left',
      tdClass: 'tr-left'
    },
    {
      key: 'licenseExpirationDate',
      label: context.$t('date'),
      sortable: true,
      thClass: 'tr-left',
      tdClass: 'tr-left'
    }
  ];
}
</script>

<style>
table.b-table > thead > tr > th.sorting:focus {
  outline: none !important;
}
.page-item.active .page-link {
  background-color: #18385f;
  border-color: #18385f;
}
.page-link:focus {
  box-shadow: none;
}
</style>
